import { HttpClient} from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';
import { CommonFunctions } from '../common-functions';
import { ApiHeaderService } from 'src/app/core/services/api-header.service';
import { StorageService } from './storage.service';
@Injectable({
  providedIn: 'root'
})
export class CouponsService {
  public server = environment.APIEndpoint;
  public CartGuesttoken = localStorage.getItem('guestUserToken');
  public urls: any = {
    applicableCoupons: this.server + 'api/order/cart/coupon/v2/applicable/list',
     applicableCouponsUnSec: this.server + 'api/unsec/order/cart/coupon/v2/list',
    applyCoupon: this.server + 'api/order/cart/coupon/v4/apply',
    applyCouponUnSecure: this.server + 'api/unsec/order/cart/coupon/v4/apply',
    deleteCouponSecure: this.server + 'api/order/cart/coupon/v2/delete',
    deleteCouponUnSecure: this.server + 'api/unsec/order/cart/coupon/v2/delete'
  };
  public deviceMetaInfo = {
    "appVersion": "",
    "deviceCountry": "India",
    "deviceCity": "",
    "deviceId": localStorage.getItem("deviceId"),
    "deviceModel": "",
    "platform": "WEB",
    "deviceOSVersion": ""
  };
  public unsecureHeaderData = {
    'Accept-Language': 'EN',
    'GuestToken': this.CartGuesttoken,
     'Device-Meta-Info': JSON.stringify(this.deviceMetaInfo)
  }
  public headerData = {
    'Accept-Language': 'EN',
    'Authorization': 'Bearer' + ' ' + this.storageService.getAccessToken(),
    'Device-Meta-Info': JSON.stringify(this.deviceMetaInfo)
  };
  isLoggedIn: any;
  constructor(private http: HttpClient,
      private storageService:StorageService,
    private commonFunction: CommonFunctions,private apiHeader: ApiHeaderService) {
    this.isLoggedIn = this.commonFunction.verifyLoggedInUser();
  }
  getApplicableCoupons(requestPayload): any {
    let isLoggedIn = this.commonFunction.verifyLoggedInUser();
     if(isLoggedIn){
      let secHeaders = this.apiHeader.getSecureHeader();
    return this.http.post(this.urls.applicableCoupons, requestPayload, { headers: secHeaders });
    }else{
      let unsecureHeaders = this.apiHeader.getUnSecureHeader();
      return this.http.post(this.urls.applicableCouponsUnSec, requestPayload, { headers: unsecureHeaders });
    }
  }
  applyCoupon(requestPayload): any {
    if(this.isLoggedIn){
     let headerData = {
        'Accept-Language': 'EN',
        'Authorization': 'Bearer' + ' ' + this.storageService.getAccessToken(),
        'Device-Meta-Info': JSON.stringify(this.deviceMetaInfo)
      };
      return this.http.post(this.urls.applyCoupon, requestPayload, { headers: headerData });
    }else{
    let unsecureHeaderData = {
        'Accept-Language': 'EN',
        'GuestToken': this.CartGuesttoken,
         'Device-Meta-Info': JSON.stringify(this.deviceMetaInfo)
      }
      return this.http.post(this.urls.applyCouponUnSecure, requestPayload, { headers: unsecureHeaderData });
    }
  }
  deleteCoupon(requestPayload): any {
    if(this.isLoggedIn){
      let secureHeaders = this.apiHeader.getSecureHeader();
      return this.http.post(this.urls.deleteCouponSecure, requestPayload, { headers: secureHeaders });
    }else{
      let unsecureHeaders = this.apiHeader.getUnSecureHeader();
      return this.http.post(this.urls.deleteCouponUnSecure, requestPayload, { headers: unsecureHeaders });
    }
  }
}
